module.exports = "#define GLSLIFY 1\nuniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\n\nvarying vec3 vWorldDirection;\n\nvoid main() {\n\n\tgl_FragColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n\tgl_FragColor.a *= opacity;\n\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/vendor/three/renderers/shaders/ShaderLib/cube_frag.glsl
// module id = 297
// module chunks = 0